<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('logs_protocol_title') }}</h3>
        <div class="g-content-filter-right">
          <a-form-model :model="searchForm" layout="inline" ref="formElement">
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="keyword">
              <a-input-search
                v-model="searchForm.keyword"
                style="min-width:200px"
                :placeholder="$t('com_form_keyword_input')"
                allowClear
                @search="getList()"
                @blur="getList()"
              />
            </a-form-model-item>

            <!-- 开始时间 -->
            <a-form-model-item :label="null" prop="date">
              <a-range-picker
                v-model="searchForm.date"
                show-time
                valueFormat="x"
                @openChange="
                  opened => {
                    if (!opened) {
                      this.getList();
                    }
                  }
                "
              />
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderField">
              <a-select
                v-model="searchForm.orderField"
                :placeholder="$t('com_form_order_field')"
                style="min-width:150px;"
                @change="getList()"
              >
                <!--0表示默认按主键，1按sn，2按通信事件类型  -->
                <a-select-option
                  :value="item.value"
                  v-for="(item, index) in $t('logs_protocol_order_field')"
                  :key="index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 排序 -->
            <a-form-model-item :label="null" prop="orderType">
              <a-select
                v-model="searchForm.orderType"
                :placeholder="$t('logs_order_type')"
                @change="getList()"
              >
                <a-select-option :value="1">
                  {{ $t('com_form_order_desc') }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ $t('com_form_order_esc') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <!-- 提交 -->
            <a-form-model-item style="margin:0">
              <a-button type="primary" @click.prevent="getList()">
                {{ $t('com_btn_search') }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="log-content">
        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" />
        <div class="g-table" v-else>
          <a-table
            :columns="columns"
            :data-source="list"
            bordered
            rowKey="id"
            :pagination="false"
            :loading="tableLoading"
            size="small"
          >
            <!-- 类型 -->
            <template slot="type" slot-scope="text">
              <!-- 通信事件类型，0-open comm.，1-close comm，2-data received，3-data sent -->
              <span v-if="$t('logs_protocol_data_type')[text]">
                {{ $t('logs_protocol_data_type')[text] }}
              </span>
              <span v-else>--</span>
            </template>

            <template slot="sn" slot-scope="text">
              <div class="g-table-text" style="min-width:50px">{{ text }}</div>
            </template>

            <template slot="MessageName" slot-scope="text">
              <div class="g-table-text" style="min-width:50px">{{ text }}</div>
            </template>

            <!-- 执行数据 -->
            <template slot="executeData" slot-scope="text, record">
              <div class="g-table-text">
                <a-icon
                  type="copy"
                  data-clipboard-action="copy"
                  title="Copy"
                  style="color:#ccc"
                  :data-clipboard-text="`${text}`"
                  :id="`logs_protocol_event_${record.id}`"
                  @click="copyContent(`#logs_protocol_event_${record.id}`)"
                />{{ text }}
              </div>
            </template>

            <!-- 时间 -->
            <template slot="createTime" slot-scope="text">
              {{ text | formatDate }}
            </template>
          </a-table>

          <Pagination
            :current="pagination.current"
            :total="pagination.total"
            :pageSize.sync="pagination.pageSize"
            :callback="getList"
            @change="getList"
            v-if="pagination.total > 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/logs';
import { copyContent } from '@/libs/utils';

export default {
  components: {},

  data() {
    return {
      copyContent,
      networkError: false,
      loading: true,
      tableLoading: false,
      // 搜索
      searchForm: {
        keyword: '',
        orderField: 0,
        orderType: 1,
        date: undefined,
      },

      endOpen: false,
      // 列表
      list: [],

      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'id',
        },
        {
          title: this.$t('logs_table_device_sn'),
          dataIndex: 'devSn',
          scopedSlots: { customRender: 'sn' },
        },
        {
          title: this.$t('logs_table_message_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'MessageName' },
        },

        {
          title: this.$t('logs_table_data'),
          dataIndex: 'data',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('logs_table_event_type'),
          dataIndex: 'commEventType',
          align: 'center',
          scopedSlots: { customRender: 'type' },
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          align: 'center',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },
    };
  },
  watch: {
    searchForm: {
      handler(form) {
        if (form.date && !form.date.length) {
          // 日期清空时调用
          this.getList();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  created() {
    this.getList();
  },
  methods: {
    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      if (this.searchForm.date && this.searchForm.date.length === 2) {
        params.date = `${this.searchForm.date[0]}-${this.searchForm.date[1]}`;
      } else {
        params.date = undefined;
      }

      this.tableLoading = true;
      this.networkError = false;

      // 获取列表
      API.MqttActionLog(params)
        .then(res => {
          this.loadSuccess(res);
        })
        .catch(err => {
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loadComplete();
        });
    },

    loadComplete() {
      this.$store.commit('setPageLoading', false);
      this.loading = false;
      this.tableLoading = false;
    },

    // 成功
    loadSuccess(res) {
      this.list = res.data || [];

      // total
      this.pagination.total = res.totalCount;
    },

    disabledStartDate(startValue) {
      const endValue = this.searchForm.endTime;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.searchForm.startTime;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
};
</script>

<style lang="less" scoped>
.logs-nav {
  a {
    margin-right: 15px;
    color: #666;
    font-size: 12px;

    &.router-link-active {
      color: #1838d9;
      font-weight: bold;
    }
  }
}
</style>
